import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import * as _ from 'lodash';
import { map, Observable } from 'rxjs';
import { ConfigService } from 'src/config';
import { TrafficDeviationReceipt, TrafficDeviationTypesUnion } from '@modules/shared/interfaces/traffic-deviations/traffic-deviation-union';
import { TrafficDeviationTypeDeviationInformation } from '@modules/shared/interfaces/traffic-deviations/traffic-deviation-type-deviation-information';
import { InformationTemplate } from '@components/traffic-deviations/stores/traffic-deviations.store';
import { TrafficDeviationInformationTemplateRequest } from '@modules/shared/interfaces/traffic-deviation-information-template/traffic-deviation-information-template-request';
import { SignalRHubHelper } from './signalr-hub.helper';

@Injectable({
    providedIn: 'root',
})
export class TaService {
    private _http = inject(HttpClient);
    private _config = inject(ConfigService);

    constructor() {}

    public registerDamageRisk(data: any): Observable<any> {
        const url = `${this._config.taApiBaseUrl}/v1/damagerisk`;
        return this._http.post(url, data).pipe(map((response) => response));
    }

    public postTrafficDeviation(
        requestObject: TrafficDeviationTypesUnion,
    ): Observable<any> {
        const url = `${this._config.taApiBaseUrl}/v1/trafficdeviations`;
        return this._http.post(url, requestObject);
    }

    public putTrafficDeviation(
        requestObject: TrafficDeviationTypesUnion,
    ): Observable<any> {
        const url = `${this._config.taApiBaseUrl}/v1/trafficdeviations`;
        return this._http.put(url, requestObject);
    }

    public recallTrafficDeviation(id: string) {
        const url = `${this._config.taApiBaseUrl}/v1/trafficdeviations/${id}`;
        return this._http.delete(url);
    }

    public getExpiredTrafficDeviations(
        garageCode: string,
        maxExpiredDate: Date,
    ): Observable<TrafficDeviationTypeDeviationInformation[]> {
        const url = `${this._config.taApiBaseUrl}/v1/deviation/${garageCode}/expired`;
        return this._http.get<TrafficDeviationTypeDeviationInformation[]>(url, {
            params: { maxExpiredDate: maxExpiredDate.toISOString() },
        });
    }

    public getExpiredTrafficDeviationReceipts(
        garageCode: string,
        maxExpiredDate: Date,
    ): Observable<TrafficDeviationReceipt[]> {
        const url = `${this._config.taApiBaseUrl}/v1/deviation/${garageCode}/receipts/expired`;
        return this._http.get<TrafficDeviationReceipt[]>(url, {
            params: { maxExpiredDate: maxExpiredDate.toISOString() },
        }).pipe(
            map((receipts) => receipts.map((r) => ({
                ...r,
                status: SignalRHubHelper.mapTrafficDeviationStatus(r.status) as number,
            }))),
        );
    }

    public getTrafficDeviationInformationTemplates() {
        const url = `${this._config.taApiBaseUrl}/v1/TrafficDeviationInformationTemplates`;
        return this._http
            .get(url)
            .pipe(map((response: InformationTemplate[]) => response));
    }

    public postTrafficDeviationInformationTemplates(
        request: TrafficDeviationInformationTemplateRequest,
    ) {
        const url = `${this._config.taApiBaseUrl}/v1/TrafficDeviationInformationTemplates`;
        return this._http.post(url, request);
    }

    public putTrafficDeviationInformationTemplates(
        request: TrafficDeviationInformationTemplateRequest,
    ) {
        const url = `${this._config.taApiBaseUrl}/v1/TrafficDeviationInformationTemplates`;
        return this._http.put(url, request);
    }

    public deleteTrafficDeviationInformationTemplates(id: string) {
        const url = `${this._config.taApiBaseUrl}/v1/TrafficDeviationInformationTemplates/${id}`;
        return this._http.delete(url);
    }
}
